export default {
    inserted(_, binding) {
        if (!binding.value) {
            return;
        }

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    },
    unbind() {
        document.body.style.overflow = 'visible';
        document.documentElement.style.overflow = 'visible';
    },
};
